export class NotesConstants {
  public static CONTINUE_ACTION_RESOURCE_KEY_PACKAGE_BUILDER = 'FC.ProductWarningsNotes.Continue.SelectProduct';
  public static CANCEL_ACTION_RESOURCE_KEY_PACKAGE_BUILDER = 'FC.ProductWarningsNotes.Cancel.SelectProduct';

  public static CONTINUE_ACTION_RESOURCE_KEY_ADD_TO_CART = 'FC.ProductWarningsNotes.Continue.AddToCart';
  public static CANCEL_ACTION_RESOURCE_KEY_ADD_TO_CART = 'FC.ProductWarningsNotes.Cancel.AddToCart';
}
